module.exports = __webpack_public_path__ + "static/media/icon_invert_disabled.8b90ebcc.svg";